<template>
    <Datepicker
        v-model="date"
        :class="`formulate-input-element formulate-input-element--${context.type}`"
        :inputClass="context.attributes.class"
        :data-type="context.type"
        :options="context.options"
        v-bind="context.attributes"
        :placeholder="
            context.attributes.hasOwnProperty('placeholder')
                ? context.attributes.placeholder
                : $i18n.t('customFormats.date')
        "
        :language="language"
        :typeable="true"
        :format="dateFormatter"
        :parser="dateParser"
        @cleared="context.rootEmit('update:date', '')"
    >
        <template #afterDateInput>
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <FormulateInput v-model="context.model"
                :label="$t('modules.people.assistentExtension')"
                name="date"
                :placeholder="$t('modules.people.assistentExtension')"
                type="hidden"
                validation="optional|extension"
                :validationMessages="{
                    extension: $t('common.crud.errors.invalidExtension'),
                }"
            />
        </template>
    </Datepicker>
</template>

<script>
import Datepicker from "@sum.cumo/vue-datepicker"
import * as lang from "@sum.cumo/vue-datepicker/dist/locale/index.esm"

export default {
    name: "FormulateCustomDate",
    components: { Datepicker },
    props: {
        context: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            language: lang[this.$i18n.locale.replace("-", "")],
        }
    },
    computed: {
        date: {
            get() {
                // Model validated with 'YYYY-MM-DD' format
                if (!this.context.model) return null

                return this.$moment(
                    this.context.model,
                    this.$moment.ISO_8601,
                    true
                ).toDate()
            },
            set(date) {
                // Date object
                if (!date) return null

                const isoDate = this.$moment(date).format("YYYY-MM-DD")

                this.context.rootEmit("update:date", isoDate)
                return isoDate
            },
        },
    },
    methods: {
        dateFormatter(date) {
            return this.$moment(date).format(this.$t("customFormats.date"))
        },
        dateParser(date) {
            return this.$moment(date, this.$t("customFormats.date"))
        },
    }
}
</script>

<style scoped>
.input > .form-control {
    background-color: #fff;
}
</style>
